import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { NewJobForm } from '@/features/linkedin-sales-navigator/components/new-job-form'

function NewJobPage() {
  return (
    <>
      <Header fixed />

      <Main className='flex flex-1 flex-col gap-4 sm:gap-6'>
        <NewJobForm />
      </Main>
    </>
  )
}

export const Route = createFileRoute(
  '/_authenticated/linkedin/sales-navigator/new'
)({
  component: NewJobPage,
})
